import { __rest } from "tslib";
import * as React from 'react';
export var CardHeaderMain = function CardHeaderMain(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      props = __rest(_a, ["children", "className"]);

  return React.createElement("div", Object.assign({
    className: className
  }, props), children);
};